(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template-ambassadors"]) return;
  try {
    
  $(window).load(function(){
    $('.slideshow').waypoint(function(direction) {
      if (direction === 'down') {
        $(this.element).addClass('selected').siblings().removeClass('selected');
      }
    }, {
      offset: '50%'
    });
    $('.slideshow').waypoint(function(direction) {
      if (direction === 'up') {
        $(this.element).addClass('selected').siblings().removeClass('selected');
      }
    }, {
      offset: '33%'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
      $(document).ready(function(){

        var arr = [],
            count_select = $('#shopify-section-filters select').length;
        $('#SortTags option').each(function () {
          arr.push($(this).val());
        });

        $('#shopify-section-filters select').each(function(){
          var originalElems = $(this),
              filterName = originalElems.find('option:first').text(),
              elems = originalElems.find('option'),
              count = elems.length,
              currSelect;

          elems.each(function(){
            if ($.inArray($(this).val(), arr) == -1 && $(this).val() != '') {
              $(this).remove();
            };
            if (!--count) {
              if(originalElems.find('option').length > 2) {
                $('.filters-toolbar').append('<div class="col-lg-12 pull-lg-12 col-md-30">' + originalElems.parent('.filter_holder').html() + '</div>');
              }
            }
          });

          if(!--count_select) {
            setTimeout(function(){
              $('.custom-select:visible').each(function() {
                var classes = $(this).attr("class"),
                    id      = $(this).attr("id"),
                    name    = $(this).attr("name");
                var template =  '<div class="' + classes + '">';
                    template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
                    template += '<div class="custom-options">';
                    $(this).find("option").each(function() {
                      if($(this).val() != '') {
                        var new_class = '';
                        if($(this).is(':selected')) {
                          new_class = ' selection';
                        }
                        template += '<span class="custom-option ' + $(this).attr("class") + new_class + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
                      } else {
                        template += '<span class="custom-option ' + $(this).attr("class") + new_class + '" data-value="' + $(this).attr("value") + '">All ' + $(this).html() + 's</span>';
                      }
                    });
                template += '</div></div>';

                $(this).wrap('<div class="custom-select-wrapper"></div>');
                $(this).hide();
                $(this).after(template);
              });
            },500);
          }
        });

        function getSizedImageUrl(src, size) {
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return prefix[0] + '_' + size + suffix;
          }
          return null;
        }
        $('.swatch-element.color:not(.morecolors)').on('click',function(){
          var var_id = $(this).data('varid'),
              sec_id = $(this).closest('.grid-view-item').data('sectionid'),
              featured_img = $(this).closest('.grid-view-item').find('.grid-view-item__image'),
              json = JSON.parse(document.getElementById('ProductJson-' + sec_id).innerHTML),
              prod_vars = json.variants;
          for(i = 0; i < prod_vars.length; ++i){
            if(var_id == prod_vars[i].id) {
              var curr_fi = prod_vars[i].featured_image;
              if(curr_fi !== null) {
                var image = getSizedImageUrl(curr_fi.src, '650x550');
                $(featured_img).css('background-image','url(' + image + ')');
              }
            }
          }
        });


        $(".custom-option:first-of-type").hover(function() {
          $(this).parents(".custom-options").addClass("option-hover");
        }, function() {
          $(this).parents(".custom-options").removeClass("option-hover");
        });
        $('body').on('click','.custom-select-trigger', function() {
          $(".custom-select").not($(this).parents(".custom-select")).removeClass("opened");
          $(this).parents(".custom-select").toggleClass("opened");
          event.stopPropagation();
        });
        $('body').on('click','.custom-option', function() {
          $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value")).trigger('change');
          $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
          $(this).addClass("selection");
          $(this).parents(".custom-select").removeClass("opened");
          $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
        });

      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template-builder"]) return;
  try {
    
  function greysize() {
    var offset = $('#builder').offset(),
        width = $('#builder').outerWidth(),
        offset_x = offset.left,
        total_offset = width + offset_x + 25;
    $('#gc').css('width',total_offset+'px');
  }

  function zoomfire() {
    $('.zoom-img').each(function(){
      var zoomUrl = $(this).data('zoom');
      $(this).zoom({
        url: zoomUrl
      });
    });
  }

  function placehold_builder() {
    // Handlebars.js layout
    var source = $("#PlaceholderTemplate").html(),
        template = Handlebars.compile(source),
        items = [],
        item = {},
        prodpicked_length = $('.single-row.prodpicked:visible').length,
        price_sub = 0;

    $('.single-row.prodpicked:visible').each(function(){
      var curr_handle = $(this).attr('data-var_handle');

      $.ajax({
        type: 'GET',
        url: '/products/'+ curr_handle +'.js',
        dataType: 'json',
        success: function(data){
          var image_normal = Shopify.resizeImage(data.featured_image,'400x'),
              item = {
                title: data.title,
                price: Shopify.formatMoney(data.price, '${{amount}}').replace(/\.00$/,''),
                image: image_normal
              };
          price_sub = price_sub + data.price;
          items.push(item);
        },
        error: function(data){
          console.log(data);
        }
      });

      if (!--prodpicked_length) {
        // Gather all  data and add to DOM
        data = {
          products: items
        }

        setTimeout(function(){
          $('#product-content').html(template(data)).prepend('<h2>Build Components</h2><hr />');
          $('.total span').text(Shopify.formatMoney(price_sub).replace(/\.00$/,''));
        },500);
      }
    });
  }

  function moveAlong(keys){
    if (keys.length) {
      var request = keys.shift(),
          temp = request,
          params = {
            type: 'POST',
            url: '/cart/add.js',
            data: temp,
            dataType: 'json',
            success: function(line_item) {
              moveAlong(keys);
            },
            error: function(jqXHR, status, err) {
              console.log(jqXHR);
              console.log(status);
              console.log(err);
              moveAlong(keys);
            }
          };
      $.ajax(params);
    } else {
      window.location.href = '{{ shop.url }}/cart';
    }
  }

  $(window).load(function(){
    greysize();
    $(window).on('resize', function(){
      greysize();
    });

    zoomfire();

    $('.builder-change').on('submit',function(e){
      e.preventDefault();
    });

    $('#lens-picker').on('change',function(){
      var nec_gear = '.' + $(this).val();
      $('#portfinder').find('.single-row:not('+ nec_gear +')').hide();
      $('#portfinder').show().find(nec_gear).show();
      $('#portfinder .single-row.prodpicked').each(function(){
        var curr_type = $(this).find('h6').data('currtype');
        $(this).hide().removeClass('prodpicked').data('var_id','').data('var_handle','').find('img-square').remove().closest('.single-row').find('h6').text(curr_type);
      });
    });

    $('#addalltocart').on('click',function(e){
        e.preventDefault();
        keys = [];
        $('.single-row.prodpicked:visible').each(function(){
          var dataObj = {};
          dataObj['quantity'] = 1;
          dataObj['id'] = $(this).attr('data-var_id');
          keys.push( dataObj );
        });
        moveAlong(keys);
    })

    $('body').on('click','.already-own',function(e){
      e.preventDefault();

      $('#product-content').empty().append('<div class="loading"></div>');

      var add_name = $(this).data('title'),
          add_image = $(this).closest('.col-md-32').next('div').find('.zoom-img').find('img').attr('src'),
          img_url = add_image.replace('_1000x', '_300x'),
          handle_class = $(this).data('handle');
      $('.currChoosing').addClass('prodskipped').attr('data-var_handle',handle_class).removeClass('currChoosing').find('.choosing').hide().closest('.single-row').prepend('<div class="img-square" style="background-image:url('+ img_url +')"></div>').find('p:not(.h6)').text(add_name).removeClass('not-selected').closest('.single-row').find('.prodstatus').text('Already Own').show();

      placehold_builder();
    });

    $('body').on('click','.add-to-kit',function(e){
      e.preventDefault();

      $('#product-content').empty().append('<div class="loading"></div>');

      var add_id = $(this).data('id'),
          add_name = $(this).data('title'),
          add_image = $(this).closest('.col-md-32').next('div').find('.zoom-img').find('img').attr('src'),
          img_url = add_image.replace('_1000x', '_300x'),
          handle_class = $(this).data('handle');
      if($('.currChoosing').closest('#portfinder').length) {
        var curr_step = $('.currChoosing').data('step'),
        next_step = curr_step + 1;
        if($('.currChoosing').nextAll('.'+handle_class+':first').length && $('.'+handle_class+':first').attr('data-step') == next_step) {
          $('.'+handle_class).show();
        } else {
          console.log('you are at the last step');
        }
      }
      $('.currChoosing').addClass('prodpicked').attr('data-var_id',add_id).attr('data-var_handle',handle_class).removeClass('currChoosing').find('.choosing').hide().closest('.single-row').prepend('<div class="img-square" style="background-image:url('+ img_url +')"></div>').find('p:not(.h6)').text(add_name).removeClass('not-selected').closest('.single-row').find('.prodstatus').text('Added').show();

      placehold_builder();
    });

    $('.edit-ajax').on('click',function(e){
      e.preventDefault();
      var $el = $(this),
          element = $el[0],
          dataMap = element.dataset;
      $('#product-content').empty().append('<div class="loading"></div>');
      $('html, body').animate({
        scrollTop: $('#product-content').offset().top + 'px'
      }, 1000, 'swing');
      $(this).closest('.single-row').addClass('currChoosing').find('.choosing').show();

      // Handlebars.js layout
      var source = $("#BuilderTemplate").html(),
          template = Handlebars.compile(source),
          items = [],
          item = {},
          count = dataMap.length;

      // Add each item to our handlebars.js data
      $.each(dataMap, function(key, prod) {
        $.ajax({
          type: 'GET',
          url: '/products/'+ prod +'.js',
          dataType: 'json',
          success: function(data){
            var image_normal = Shopify.resizeImage(data.featured_image,'750x'),
                image_zoom = Shopify.resizeImage(data.featured_image,'1000x'),
                description_full = data.description,
                description = description_full.split('<h6>');
            item = {
              title: data.title,
              variantsku: data.variants[0].sku,
              price: Shopify.formatMoney(data.price, '${{amount}}').replace(/\.00$/,''),
              description: description[0],
              variantid: data.variants[0].id,
              handle: data.handle,
              url: data.url,
              image: image_normal,
              imagezoom: image_zoom
            };
            items.push(item);
          },
          error: function(data){
            console.log(data);
          }
        });

        if (!--count) {
          // Gather all  data and add to DOM
          data = {
            products: items
          }

          setTimeout(function(){
            $('#product-content').html(template(data));
            setTimeout(function(){
              zoomfire();
            },100);
          },500);
        }
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  (function(){
    var d = document,
    accordionToggles = d.querySelectorAll('.js-accordionTrigger'),
    setAria,
    setAccordionAria,
    switchAccordion,
    touchSupported = ('ontouchstart' in window),
    pointerSupported = ('pointerdown' in window);

    skipClickDelay = function(e){
      e.preventDefault();
      e.target.click();
    }

      setAriaAttr = function(el, ariaType, newProperty){
      el.setAttribute(ariaType, newProperty);
    };
    setAccordionAria = function(el1, el2, expanded){
      switch(expanded) {
        case "true":
          setAriaAttr(el1, 'aria-expanded', 'true');
          setAriaAttr(el2, 'aria-hidden', 'false');
          break;
        case "false":
          setAriaAttr(el1, 'aria-expanded', 'false');
          setAriaAttr(el2, 'aria-hidden', 'true');
          break;
        default:
          break;
      }
    };

    switchAccordion = function(e) {
      e.preventDefault();
      var thisAnswer = e.target.parentNode.nextElementSibling;
      var thisQuestion = e.target;
      if(thisAnswer.classList.contains('is-collapsed')) {
        setAccordionAria(thisQuestion, thisAnswer, 'true');
      } else {
        setAccordionAria(thisQuestion, thisAnswer, 'false');
      }
      thisQuestion.classList.toggle('is-collapsed');
      thisQuestion.classList.toggle('is-expanded');
      thisAnswer.classList.toggle('is-collapsed');
      thisAnswer.classList.toggle('is-expanded');

      thisAnswer.classList.toggle('animateIn');
    };
    for (var i=0,len=accordionToggles.length; i<len; i++) {
      if(touchSupported) {
        accordionToggles[i].addEventListener('touchstart', skipClickDelay, false);
      }
      if(pointerSupported){
        accordionToggles[i].addEventListener('pointerdown', skipClickDelay, false);
      }
      accordionToggles[i].addEventListener('click', switchAccordion, false);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  $(document).ready(function(){
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
